import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef } from "react";
export const MainContent = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("main", {
        ref: forwardedRef,
        className: tailwindMerge("relative flex h-[inherit] flex-1 flex-col overflow-y-auto", className),
        ...restOfProps
    });
});
MainContent.displayName = "Main";
